

const env = process.env.NODE_ENV;
console.log("env=="+env);


var protocol = "https:";//"";//
var host = "c.ovege.cn";//47.120.53.189"; //api访问路径
var appHost=protocol+"//"+host;//http://47.120.53.189";//客户端页面访问路径



//接口地址
//var serviceDaoduHost=protocol+"//woaixiaoshu.com/serviceDaodu";//生产环境
var orderHost = protocol + "//" + host +"/orderservice";// ":6034";
var userHost = protocol + "//" + host + "/userservice";//:6014";
if (env == "development") {
	//serviceDaoduHost=protocol+"//49.235.140.46:6026";
	//orderHost = protocol + "//47.120.53.189:6034";
	//userHost = protocol + "//47.120.53.189:6014";
}

//接口路径
var contextPath = ""; ///qianxueapi";//"/aeongiftcard/h5api";//"/wdkapi";



// 以下在axios中配置
// if(env=="production"){
//     host="http://27.154.227.54";//"";//"http://localhost:8080";
//     contextPath="/aeongiftcard/h5api";//"";//"/wdkapi";
// }

const url={

	
	//公共(ydsj & fg)
	//updateIsPassLevelForYdsjfg:serviceDaoduHost+contextPath+"/ydsjfg/updateIsPassLevel",
	shenqing: userHost + "/shenqing/save",
	checkShenqing: userHost + "/admin/shenqing/check",
	getShenqingList: userHost + "/admin/shenqing/list",
	getShenqingDetail: userHost + "/shenqing/detail",
	getPhoneNumber: userHost + "/user/getPhoneNumber",
	getMyUrlPermission: userHost + "/user/getMyUrlPermission",
	updateNickName: userHost + "/user/updateNickName",
	getMyPullUser: userHost + "/user/getMyPullUser",

	getMyMoney: userHost + "/user/getMyMoney",
	getUserInfo: userHost + "/user/getUserInfo",
	getAdvList: userHost + "/adv/getByPosition",
	getLastOrderGoods: orderHost + "/order/getLastOrderGoods",

	getToken: userHost + "/user/getToken",
	checkUserLoginState: userHost + "/user/checkUserLoginState",
	doLogin: userHost + "/user/login",
	
	//order
	gethbinfo: orderHost + "/pay/payout/wxpay_gethbinfo",
	wxpay_sendredpack: orderHost + "/pay/payout/wxpay_sendredpack",
	getCashoutList: orderHost + "/pay/payout/list",
	getGoodsList: orderHost + "/goods/list",
	getGoodsCategoryList: orderHost + "/admin/goodscategory/list", 
	getGoodsDetail: orderHost + "/goods/detail",
	getLiushuiList: orderHost + "/liushui/list",

	
	getWxmpPayParams: orderHost + "/order/getWxmpPayParams",
	//uploadFile: orderHost+"/admin/goods/upload/file",
	

	getShopList: userHost + "/shop/list", //开通礼品卡shop list
	sendSmsCode: userHost + "/user/sendsmscode",
	//===============

	createUserByWxmp: userHost + "/user/createUserByWxmp", //参数wxmpAppId,code,fromChannel,fromUid
	getShopDetail: userHost + "/shop/detail",
	getGoodsSpecItemList: orderHost + "/goodsspecitem/getByIds",
	saveContact: userHost + "/contact/save",
	getContactList: userHost + "/contact/list",
	getContactDetail: userHost + "/contact/detail",
	deleteContact: userHost + "/contact/delete",

	saveOrder: orderHost + "/order/save",
	getOrderList: orderHost + "/order/list",
	getLastOrderContact: orderHost + "/order/getLastOrderContact",
	createOrder: orderHost + "/order/save",
	getOrderCountByState: orderHost + "/order/getOrderCountByState",
	getOrderDetail: orderHost + "/order/detail",
	cancelOrder: orderHost + "/order/cancel",
	getPeisongAmount: orderHost + "/order/getPeisongAmount",
	acceptPeisong: orderHost + "/order/acceptPeisong",

	updatePhone: userHost + "/user/updatePhone",
	sendSmscode: userHost + "/user/sendsmscode",
	uploadFile: userHost + "/user/uploadfile",
	updatePhoto: userHost + "/user/updatePhoto",
	getMpQrcode: userHost + "/user/getMpQRCode",
	getShareQrcode: userHost + "/user/getShareQRCode",
	
	getLiushuiList: orderHost + "/liushui/list",
	//getVerifyImg: userHost + "/imgverify/getimg",
	getImgVerifyCode: userHost + "/imgverify/getYuandianImg",
	doImgVerify: userHost + "/imgverify/doverify",
	payByCoupon: orderHost + "/order/payByCoupon",
	payByWap: orderHost + "/order/payByWap",
	payByPage: orderHost + "/order/payByPage",

	getCategoryList: userHost + "/category/list",
	getAreaList: userHost + "/district/getAll",

	getArticleList: userHost + "/article/list",

		/****************old**/
    // getData:host+contextPath+"/order/checkin",
    // getMemberAccinfo:host+contextPath+"/member/accinfo",
    // setMemberAccinfo:host+contextPath+"/member/setaccinfo",
    // getPayCode:host+contextPath+"/b2cpay/paycode",
    // getCardInfoForBuy:host+contextPath+"/buycard/showinfo",//购卡信息
    // getCardSumForBuy:host+contextPath+"/buycard/calculateamount",//购卡金额
    // getRsaPubkey:host+contextPath+"/tools/getrsapubkey",//获取rsa加密公钥
    // decrsadata:host+contextPath+"/tools/decrsadata",//解密测试
    // doPay:host+contextPath+"/cardpay/reqpay",	//提交支付
    // cancelPay:host+contextPath+"/cardpay/cancelpay",	//取消支付
    // getPayResult:host+contextPath+"/b2cpay/queryresult",//查询支付结果				

    // setPaypwd:host+contextPath+"/member/setpaypwd",
    // sendSms:host+contextPath+"/tools/sendsmsvc",//发送短信验证码
    // checkSms:host+contextPath+"/tools/checksmsvc",
    // createOrderForBuyCard:host+contextPath+"/buycard/unifiedorder",
    // getCardList:host+contextPath+"/cardbag/cardlist", //卡包 列表
    // getCardDetail:host+contextPath+"/cardbag/cardinfo", //卡包 详情
    // reqShare:host+contextPath+"/sharecard/reqshare", //转增
    // confirmShare:host+contextPath+"/sharecard/confirmshare", //转增
    // refundShare:host+contextPath+"/sharecard/refund",
    // receiveShare:host+contextPath+"/sharecard/receive", //领卡
    // getRedInfo:host+contextPath+"/redpacket/showinfo",//发红包信息
	// reqSendRed:host+contextPath+"/redpacket/reqsend",// 请求发红包			
	// getMyInRedList:host+contextPath+"/redpacket/myreceive",//  收到红包列表
    // getMyOutRedList:host+contextPath+"/redpacket/mysend",//  发出红包列表
    // getExchangecardInfo:host+contextPath+"/exchangecard/showinfo",// 积分换卡信息
    // createOrderForExchangecard:host+contextPath+"/exchangecard/unifiedorder",// 积分换卡下单					

    // reqBind:host+contextPath+"/bindcard/reqbind",//请求绑定
    // getSmsCard:host+contextPath+"/smscard/querybysmskey",// 查询可领取卡
    // receiveSmsCard:host+contextPath+"/smscard/receive",// 领取短信发卡
    // queryForBuycard:host+contextPath+"/buycard/queryresult",// 购卡结果查询

    // translist:host+contextPath+"/transquery/translist",// 交易列表
	// transdetail:host+contextPath+"/transquery/transdetail",
    // receiveRedpacket:host+contextPath+"/redpacket/receive",

    // getHtml:host+contextPath+"/htmlpage/getcontent",
    // checkpaypwd:host+contextPath+"/member/checkpaypwd",//预校验支付密码	
    // shoplist:host+contextPath+"/organ/enablelist",//开通礼品卡shop list


};


const resCode = {
	SUCCESS: "1000",
	UNSUCCESS: "1001",
	UNLOGIN: "1002",
	PARAMSERROR: "1003",
	FREEZE: "1004",
	PASSWORDERROR: "1005",
	UNPERMISSION: "1006",
	ERROR_COUNT_OVER: "1008",
	TOKEN_ERROR:"1009", //"token过期或错误,需重新获取");
	WAIT_CONFIRM:"1010",// "结果待确认");
			
	ACCOUNT_REPEAT: "2000",
	USER_NOT_EXIST: "2001",
	ORG_OUT_BOUNDS: "2002",
	NEED_SHOP: "2003",
	NOT_OLD_DATA: "2004",
	CREATE_USER_ERROR: "2005",
	CREATE_STAFF_ERROR: "2006",
	IS_REPEAT: "2007",
	NOT_ORG: "2008",
	NOT_TYPE: "2009",
	NOT_STORE: "2009",
	VERIFY_TIMEOUT: "2010",


};

/**
 * 复制一个tabbar供页面调用（须与pages.json同步）
 * 增加一些与tabbar对应的数据，如pc页面配置
 */
const tabbar = [
        {
          "path": "/tabbar_index_index",
          "icon": require("@/assets/images/b2.png"),  //@/：指向 src/ 目录.使用绝对路径：@/assets/ 比相对路径更可靠,,组件中使用可require预加载
          "selectedIcon": require("@/assets/images/b2_on.png"),
          "title": "首页"
        },
        {
          "path": "/tabbar_goods_index",
          "icon": require("@/assets/images/b3.png"),
          "selectedIcon": require("@/assets/images/b3_on.png"),
          "title": "商品"
        },
        {
          "path": "/tabbar_cart_index",
          "icon": require("@/assets/images/b8.png"),
          "selectedIcon": require("@/assets/images/b8_on.png"),
          "title": "购物车",
          "badge": 0
        },
        {
          "path": "/tabbar_user_index",
          "icon": require("@/assets/images/b4.png"),
          "selectedIcon": require("@/assets/images/b4_on.png"),
          "title": "我的"
        }
      
	// {
	// 	path: "pages/tabbar/index/index", //仅本项是复制过来的（须与pages.json同步）(通常为一级栏目的index)
	// 	secondIndex: "pages/goods/list", //二级栏目首个main页面path
	// 	h5LeftPath: "pages/tabbar/goods/item", //left页面
	// 	h5LeftName: "goodsCategory", //import组件名,与页面实际import component名对应
	// 	matchFolder: "goods", //本项匹配的页面文件夹名称（route的第二级）,多个可逗号分隔
	// },
	// {
	// 	path: "pages/tabbar/goods/index",
	// 	secondIndex: "pages/goods/list",
	// 	h5LeftPath: "pages/tabbar/zixun/item",
	// 	h5LeftName: "zixunCategory",
	// 	matchFolder: "goods"
	// },
	// {
	// 	path: "pages/tabbar/cart/index",
	// 	secondIndex: "pages/tabbar/cart/index",
	// 	h5LeftPath: "pages/tabbar/order/item",
	// 	h5LeftName: "orderCategory",
	// 	matchFolder: "cart"
	// },
	// {
	// 	path: "pages/tabbar/user/index",
	// 	secondIndex: "pages/user/home",
	// 	h5LeftPath: "pages/tabbar/user/item",
	// 	h5LeftName: "userCategory",
	// 	matchFolder: "user"
	// }
];

//订单状态(非专项状态)
const state={
  order_create:"order_create",
  order_goods_return_finish:"order_goods_return_finish",
  order_goods_send_finish:"order_goods_send_finish",// "商品交付完成");
  order_canceled:"order_canceled",// "已取消");
  order_pay_part:"order_pay_part",// "已部分支付");
  order_pay_finish:"order_pay_finish",// "支付完成");
  order_refund_finish:"order_refund_finish",// "已退款");
  order_peisong_called:"order_peisong_called",// "已呼叫配送");
  order_goods_to_peisong:"order_goods_to_peisong",// "商品已交配送，正在配送中");
}


//shop专属配置
var appId="";
// #ifdef H5
	appId="xsf4f0453905c0deca";//小蔬直营-h5：xs3df89a763c6bacff，礼著 xs3df89a763c6cc235 ，扣肉直营 xsf4f0453905c0deca
// #endif
// #ifdef MP
	// const accountInfo = uni.getAccountInfoSync();
	// try{ appI
	// d=accountInfo.miniProgram.appId; }catch(e){ console.log(e); }
// #endif		
const logo = userHost+"/file/upload/adv/kourou_logo.png";//lz_logo.png";//rgm_logo.png";//brand_gsm.png";//xs_logo_img.png";//mc_logo.png";//
const appName = "我爱梅菜扣肉";//"礼著";//"我爱热干面";//"我爱小蔬";//"我爱雪糕";//！！！需修改清单文件 //
const appBasePath="";//！！！可能需修改清单文件运行路径 // 
const adv_word="唤醒美妙时分";
const adv_word_s="均衡·自然·营养";//"挚爱岩茶";//"番茄·玉米·茯苓糕";//"雪糕·牛奶·冰淇淋";//"";//
const shopType = "kourou_node";//"lizhu_node";//"rgm_node";//gsm_node";//"xs_node";//"mc_node
const advPosition = {
	index:"kourou_index_top",//"huazhu_wxmp_index", //"rgm_wxmp_index_top", //"gsm_wxmp_index_top", //"xs_wxmp_index_top", //"mc_wxmp_index_top", //
	// huisuo_wxmp_index_top:"huisuo_wxmp_index_top",// "会所-微信小程序首页顶部",
	// xs_wxmp_index_top:"xs_wxmp_index_top", //"小蔬-微信小程序首页顶部",
	// huazhu_wxmp_index:"huazhu_wxmp_index", //"花渚-微信小程序-首页",
	// huazhu_wxmp_brand_top:"huazhu_wxmp_brand_top",// "花渚-微信小程序-品牌介绍-顶部",
	// huazhu_wxmp_brand_middle:"huazhu_wxmp_brand_middle",// "花渚-微信小程序-品牌介绍-中部",
	// huazhu_wxmp_goods_index:"huazhu_wxmp_goods_index", //"花渚-微信小程序-商城首页",
		
};

export default {
	host,
	userHost,
	url,
	resCode,
	tabbar,
	state,
	appHost,appBasePath,
	
	appName,
	advPosition,
	shopType,
	adv_word,
	adv_word_s,
	logo,
	appId
}




// WEBPACK FOOTER //
// ./src/utils/config.js